import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { IMAGE_QUERY_PARAMS } from '../constants.js';
import { toOrderDetails } from '../mappers/view/orders/order-details.js';
import { GET_ORDER_DETAILS } from '../operations/queries/get-order-details.js';

const useGetOrderDetails = (orderNumber)=>{
    const intl = useIntl();
    const { data , loading , error  } = useQuery(GET_ORDER_DETAILS, {
        variables: {
            orderNumber
        }
    });
    const detailOrder = toOrderDetails(data === null || data === void 0 ? void 0 : data.me.order, intl, {
        imageQueryParams: IMAGE_QUERY_PARAMS
    });
    return {
        data: detailOrder || undefined,
        loading,
        error
    };
};

export { useGetOrderDetails };
//# sourceMappingURL=use-get-order-details.js.map
